import { isSelfHostedDistribution } from "utils/distribution";

import useSelfHostedFlags from "./useSelfHostedFlags";
import useTypedFlags from "./useTypedFlags";

const isSelfHosted = isSelfHostedDistribution();

const useSelfServiceFlags = () => {
  const { enableSelfServiceV2 } = useTypedFlags();
  const { enableSelfServiceV2: enableSelfServiceV2SelfHosted } = useSelfHostedFlags();

  if (isSelfHosted) {
    return {
      enableSelfServiceV2: enableSelfServiceV2SelfHosted,
    };
  }

  return {
    enableSelfServiceV2,
  };
};

export default useSelfServiceFlags;
